import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TitreDescriptionComponent } from '@components/titre-description';
import { TitreDescriptionMenuVisuel } from '@components/titre-description-menu-visuel/models';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';

@Component({
  selector: 'app-titre-description-menu-visuel',
  imports: [TitreDescriptionComponent, ImageComponent, ButtonComponent, NgClass, NgTemplateOutlet],
  templateUrl: './titre-description-menu-visuel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitreDescriptionMenuVisuelComponent extends AbstractDynamicComponent<TitreDescriptionMenuVisuel> {}
